import React from 'react'

function InterviewQuestionCategoryStencil({ classes }) {
    return (
        <div>
            <div class={`edu-blog-widget-2 widget-categories ${classes ? classes : ""}`}>
                <div class="inner">
                    <h5 className="placeholder-glow mb--30">
                        <span className="placeholder w-50 bg-smoke"></span>
                    </h5>
                    <div class="content">
                        <ul class="category-list">

                            <li>
                                <div className="w-100 d-flex gap-3 align-items-center justify-content-between mt--10">
                                    <div className="price w-50 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </li>
                            <li>
                                <div className="w-100 d-flex gap-3 align-items-center justify-content-between mt--10">
                                    <div className="price w-50 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </li>
                            <li>
                                <div className="w-100 d-flex gap-3 align-items-center justify-content-between mt--10">
                                    <div className="price w-50 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </li>
                            <li>
                                <div className="w-100 d-flex gap-3 align-items-center justify-content-between mt--10">
                                    <div className="price w-50 h-100 placeholder placeholder-glow bg-smoke"></div>
                                    <div className="price w-25 h-100 placeholder placeholder-glow bg-smoke"></div>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InterviewQuestionCategoryStencil
